import React, { useState } from "react";
import { VsiSmallText } from "../styled/App.styled";
import DriveIconSvg from "./DriveIconSvg";
import { returnDriveColor } from "../utils/Helpers";
import { Popover, PopoverBody, PopoverHeader, Table } from "reactstrap";
import themeStyles from "../utils/themeStyles";
import { useVsiAppContext } from "../stores/VsiApp";
import { withErrorBoundary } from "../boundaries/withErrorBoundary";
import GeneralErrorBoundary from "../boundaries/GeneralErrorBoundary";

const driveStyle = {
	backgroundColor: 'rgb(255, 255, 255, .1)',
	borderRadius: '5px',
};

const popoverDefs = [
	{
		label: "Drive Serial",
		field: "drive_serial_number",
	},
	{
		label: "Drive Type",
		field: "drive_type",
	},
	{
		label: "Failed",
		field: "is_failed",
	},
	{
		label: "Hot Spare",
		field: "is_hot_spare",
	},
	{
		label: "Firmware Revision",
		field: "revision",
	},
	{
		label: "Drive Size",
		field: "size",
	},
	{
		label: "Drive Speed",
		field: "speed",
	},
	{
		label: "Slot #",
		field: "slot",
	},
]

const determineTdVal = (val, field) => {
	if (typeof val === 'boolean' || typeof val === 'number' && ['is_failed', 'is_hot_spare'].includes(field)) {
		return val ? 'Yes' : 'No';
	} else if (typeof val === "number") {
		return val.toLocaleString();
	} else {
		return val;
	}
}

function DriveDiagram ({ drive }) {
	const { theme } = useVsiAppContext();
	const [isOpen, setIsOpen] = useState(false);
	const togglePopover = () => setIsOpen(!isOpen);
	return <div style={{ display: 'inline-block'}}>
		<div className={"d-flex flex-column"}>
			<div className={"p-1"} id={`drive-${drive?.device_physical_diagram_id}`}>
				<div className={"py-1"} style={{
					...driveStyle,
					cursor: drive?.device_physical_diagram_id ? 'pointer' : 'default'
				}} onClick={togglePopover}>
					<DriveIconSvg color={returnDriveColor(drive, themeStyles[theme])}/>
				</div>
			</div>
			{drive?.disk_group && <VsiSmallText className={"my-2 text-center"}>{drive.disk_group}</VsiSmallText>}
		</div>
		{drive?.device_physical_diagram_id ? <Popover
			flip
			target={`drive-${drive?.device_physical_diagram_id}`}
			isOpen={isOpen}
			toggle={togglePopover}
		>
			<PopoverHeader className={"d-flex flex-row justify-content-between"}>
				<span>
					Drive Details
				</span>
				<span>
					<i className="fa-solid fa-x" style={{ cursor: 'pointer'}} onClick={togglePopover}/>
				</span>
			</PopoverHeader>
			<PopoverBody>
				<Table>
					<tbody>
					{popoverDefs.map((def, index) => (
							<tr key={`def-${index}-${def.field}-${drive.disk_group}`}>
								<th scope={"row"}>
									{def.label}:
								</th>
								<td>
									{determineTdVal(drive?.[def.field], def.field)}
								</td>
							</tr>
						))}
					</tbody>
				</Table>
			</PopoverBody>
		</Popover> : null}
	</div>
}

DriveDiagram.displayName = "DriveDiagram"

export default withErrorBoundary(DriveDiagram, GeneralErrorBoundary);
